import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, SxProps, Typography} from '@mui/material';

import {bodyPdf, pdfH1} from './styles';
import {CultureAnalysisPdfContext} from '../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {LanguageContext} from '../../../contexts/LanguageContext/LanguageContext';
import {orangeColors} from '../../../layouts/theme/designSystem';

export const EmpionRecommendationsFirstPage = () => {
  const {t} = useTranslation('pdfDomain');
  const currentLanguage = useContext(LanguageContext);

  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const empionRecommendations = data.empionRecommendations.slice(0, 3);

  const paperStyles: SxProps = {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    padding: 2,
    backgroundColor: orangeColors[5],
    boxShadow: 'none',
    width: '330px',
    borderRadius: '16px',
  };

  const renderEmpionRecommendedActions = () => {
    const textBlocks = (
      <Grid item bgcolor={orangeColors[3]} p={2} borderRadius={'16px'} width={'330px'} key='textBlocks'>
        <Typography sx={bodyPdf} color={orangeColors[900]} mb={1}>
          {t('empionRecommendations.textBlocks.one')}
        </Typography>
        <Typography sx={bodyPdf} color={orangeColors[900]}>
          {t('empionRecommendations.textBlocks.two')}
        </Typography>
      </Grid>
    );

    const recommendations = empionRecommendations.map((item, index) => (
      <Grid container item sx={paperStyles} key={index}>
        <Box
          bgcolor={orangeColors[5]}
          border={`1px solid ${orangeColors[3]}`}
          borderRadius={'50%'}
          height={20}
          width={20}
          textAlign={'center'}
          alignContent={'center'}
          mb={1}
        >
          <Typography sx={bodyPdf} fontWeight={700}>
            {index + 1}
          </Typography>
        </Box>
        <Typography sx={bodyPdf} mb={2}>
          {item.recommendationText[currentLanguage]}
        </Typography>
      </Grid>
    ));

    return [textBlocks, ...recommendations];
  };

  return (
    <>
      <Grid container px={5} pt={5}>
        <Typography variant='h1' sx={pdfH1}>
          {t('empionRecommendations.title')}
        </Typography>
        <Typography variant='h1' sx={pdfH1} ml={1}>
          1/2
        </Typography>
        <Grid item container gap={3} mt={5} justifyContent={'center'}>
          {renderEmpionRecommendedActions()}
        </Grid>
      </Grid>
    </>
  );
};
